import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tour-popover-container"
}
const _hoisted_2 = { class: "tour-pop-icon" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fa fa-redo-alt" }, null, -1)
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("div", { class: "tour-icon-wrap" }, [
    /*#__PURE__*/_createVNode("div", { class: "icon-wrapper text-center" }, [
      /*#__PURE__*/_createVNode("i", { class: "fa fa-window-restore" })
    ])
  ])
], -1)
const _hoisted_6 = { class: "col-8" }
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = { class: "row align-items-center" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showTour)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("a", {
            href: "javascript:void(0)",
            title: "Take a tour",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showTourGuidePopUp && _ctx.showTourGuidePopUp(...args)))
          }, [
            _hoisted_3
          ])
        ]),
        _createVNode("div", {
          class: 
        _ctx.toggleTour ? 'tour-pop-wrap card disappear-block' : 'tour-pop-wrap card'
      
        }, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode("h5", null, _toDisplayString(_ctx.$t('convorally_active_message')), 1),
              _createVNode("p", _hoisted_7, [
                _createVNode("small", null, _toDisplayString(_ctx.$t('want_to_see_message')), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn mt-2",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.takeATour && _ctx.takeATour(...args)))
              }, _toDisplayString(_ctx.$t('take_a_tour')), 1)
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "mt-2",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.noThanks && _ctx.noThanks(...args)))
              }, _toDisplayString(_ctx.$t('no_thanks')), 1)
            ])
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}